import ProductAddedToCartModal from './ProductAddedToCartModal';

export default ProductAddedToCartModal;


// WEBPACK FOOTER //
// ./src/components/ProductAddedToCartModal/index.jsx